




















import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import PasswordModel from './models/passwordModel'
import registrationMixin from './registrationMixin'

export default mixins(registrationMixin, mobileTypeMixin).extend({
    data() {
        return {
            model: new PasswordModel()
        }
    },
    mounted() {
        this.init(this.model)
    },
    methods: {
        confirm() {
            this.validate(this.model)
        }
    }
})
